import { checkpoint_vehicleService } from '../_services';

const state = { onRequest: false, checkpoint_vehicle: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        checkpoint_vehicleService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  checkpoint_vehicle: state => {
    return state.checkpoint_vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.checkpoint_vehicle = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.checkpoint_vehicle = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.checkpoint_vehicle = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const checkpoint_vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
